import { render, staticRenderFns } from "./firefightingEquipmentInfoDetail.vue?vue&type=template&id=6915ea84"
import script from "./firefightingEquipmentInfoDetail.vue?vue&type=script&lang=js"
export * from "./firefightingEquipmentInfoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6915ea84')) {
      api.createRecord('6915ea84', component.options)
    } else {
      api.reload('6915ea84', component.options)
    }
    module.hot.accept("./firefightingEquipmentInfoDetail.vue?vue&type=template&id=6915ea84", function () {
      api.rerender('6915ea84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/ffe/firefightingEquipmentInfoDetail.vue"
export default component.exports